// The share of the answer scale that a self-declared average represents —
// the one arithmetic behind every Harvey ball and bar on the dashboard and
// the report: (average − scale minimum) / (scale maximum − scale minimum),
// clamped to 0..1. Presentation of a number the report model already holds,
// not a result of its own: an average of 2.0 on a 0–3 scale is 67 % of the
// way from "Not in place" to "Fully in place". It is never called a maturity
// level and never shown without the number it draws.

export function shareOfScale(average: number | null, scale: { min: number; max: number }): number | null {
  if (average === null) return null;
  const span = scale.max - scale.min;
  if (span <= 0) return null;
  const share = (average - scale.min) / span;
  return Math.max(0, Math.min(1, share));
}

/** The share as a whole percentage for a label, e.g. 67. */
export function percentOfScale(average: number | null, scale: { min: number; max: number }): number | null {
  const s = shareOfScale(average, scale);
  return s === null ? null : Math.round(s * 100);
}
